// Moved: the spec Zod schemas now live in @modelcontextprotocol/core (packages/core/src/schemas.ts).
// This module re-exports them one-to-one so every existing import path keeps working; a name
// added to core/src/schemas.ts must be added here too (specTypeSchema.ts imports through this
// module, so a missing name fails typecheck loudly).
//
// Add new schemas in packages/core/src/schemas.ts, never here — this file only forwards, and
// core-internal's schemaShims test enforces that it stays free of zod imports and definitions.
export {
    AnnotationsSchema,
    AudioContentSchema,
    BaseMetadataSchema,
    BaseRequestParamsSchema,
    BlobResourceContentsSchema,
    BooleanSchemaSchema,
    CallToolRequestParamsSchema,
    CallToolRequestSchema,
    CallToolResultSchema,
    CancelledNotificationParamsSchema,
    CancelledNotificationSchema,
    CancelTaskRequestSchema,
    CancelTaskResultSchema,
    ClientCapabilitiesSchema,
    ClientNotificationSchema,
    ClientRequestSchema,
    ClientResultSchema,
    ClientTasksCapabilitySchema,
    CompatibilityCallToolResultSchema,
    CompleteRequestParamsSchema,
    CompleteRequestSchema,
    CompleteResultSchema,
    ContentBlockSchema,
    CreateMessageRequestParamsSchema,
    CreateMessageRequestSchema,
    CreateMessageResultSchema,
    CreateMessageResultWithToolsSchema,
    CreateTaskResultSchema,
    CursorSchema,
    DiscoverRequestSchema,
    DiscoverResultSchema,
    ElicitationCompleteNotificationParamsSchema,
    ElicitationCompleteNotificationSchema,
    ElicitRequestFormParamsSchema,
    ElicitRequestParamsSchema,
    ElicitRequestSchema,
    ElicitRequestURLParamsSchema,
    ElicitResultSchema,
    EmbeddedResourceSchema,
    EmptyResultSchema,
    EnumSchemaSchema,
    GetPromptRequestParamsSchema,
    GetPromptRequestSchema,
    GetPromptResultSchema,
    GetTaskPayloadRequestSchema,
    GetTaskPayloadResultSchema,
    GetTaskRequestSchema,
    GetTaskResultSchema,
    IconSchema,
    IconsSchema,
    ImageContentSchema,
    ImplementationSchema,
    InitializedNotificationSchema,
    InitializeRequestParamsSchema,
    InitializeRequestSchema,
    InitializeResultSchema,
    JSONArraySchema,
    JSONObjectSchema,
    JSONRPCErrorResponseSchema,
    JSONRPCMessageSchema,
    JSONRPCNotificationSchema,
    JSONRPCRequestSchema,
    JSONRPCResponseSchema,
    JSONRPCResultResponseSchema,
    JSONValueSchema,
    LegacyTitledEnumSchemaSchema,
    ListChangedOptionsBaseSchema,
    ListPromptsRequestSchema,
    ListPromptsResultSchema,
    ListResourcesRequestSchema,
    ListResourcesResultSchema,
    ListResourceTemplatesRequestSchema,
    ListResourceTemplatesResultSchema,
    ListRootsRequestSchema,
    ListRootsResultSchema,
    ListTasksRequestSchema,
    ListTasksResultSchema,
    ListToolsRequestSchema,
    ListToolsResultSchema,
    LoggingLevelSchema,
    LoggingMessageNotificationParamsSchema,
    LoggingMessageNotificationSchema,
    ModelHintSchema,
    ModelPreferencesSchema,
    MultiSelectEnumSchemaSchema,
    NotificationSchema,
    NotificationsParamsSchema,
    NumberSchemaSchema,
    PaginatedRequestParamsSchema,
    PaginatedRequestSchema,
    PaginatedResultSchema,
    PingRequestSchema,
    PrimitiveSchemaDefinitionSchema,
    ProgressNotificationParamsSchema,
    ProgressNotificationSchema,
    ProgressSchema,
    ProgressTokenSchema,
    PromptArgumentSchema,
    PromptListChangedNotificationSchema,
    PromptMessageSchema,
    PromptReferenceSchema,
    PromptSchema,
    ReadResourceRequestParamsSchema,
    ReadResourceRequestSchema,
    ReadResourceResultSchema,
    RelatedTaskMetadataSchema,
    RequestIdSchema,
    RequestMetaSchema,
    RequestSchema,
    ResourceContentsSchema,
    ResourceLinkSchema,
    ResourceListChangedNotificationSchema,
    ResourceRequestParamsSchema,
    ResourceSchema,
    ResourceTemplateReferenceSchema,
    ResourceTemplateSchema,
    ResourceUpdatedNotificationParamsSchema,
    ResourceUpdatedNotificationSchema,
    ResultMetaObjectSchema,
    ResultSchema,
    RoleSchema,
    RootSchema,
    RootsListChangedNotificationSchema,
    SamplingContentSchema,
    SamplingMessageContentBlockSchema,
    SamplingMessageSchema,
    ServerCapabilitiesSchema,
    ServerNotificationSchema,
    ServerRequestSchema,
    ServerResultSchema,
    ServerTasksCapabilitySchema,
    SetLevelRequestParamsSchema,
    SetLevelRequestSchema,
    SingleSelectEnumSchemaSchema,
    StringSchemaSchema,
    SubscribeRequestParamsSchema,
    SubscribeRequestSchema,
    SubscriptionFilterSchema,
    SubscriptionsAcknowledgedNotificationParamsSchema,
    SubscriptionsAcknowledgedNotificationSchema,
    SubscriptionsListenRequestParamsSchema,
    SubscriptionsListenRequestSchema,
    SubscriptionsListenResultMetaSchema,
    SubscriptionsListenResultSchema,
    TaskAugmentedRequestParamsSchema,
    TaskCreationParamsSchema,
    TaskMetadataSchema,
    TaskSchema,
    TaskStatusNotificationParamsSchema,
    TaskStatusNotificationSchema,
    TaskStatusSchema,
    TextContentSchema,
    TextResourceContentsSchema,
    TitledMultiSelectEnumSchemaSchema,
    TitledSingleSelectEnumSchemaSchema,
    ToolAnnotationsSchema,
    ToolChoiceSchema,
    ToolExecutionSchema,
    ToolListChangedNotificationSchema,
    ToolResultContentSchema,
    ToolSchema,
    ToolUseContentSchema,
    UnsubscribeRequestParamsSchema,
    UnsubscribeRequestSchema,
    UntitledMultiSelectEnumSchemaSchema,
    UntitledSingleSelectEnumSchemaSchema
} from '@modelcontextprotocol/core/internal';
